<template>
  <ChangePassword />
</template>

<script>
import ChangePassword from "@/components/ChangePassword";

export default {
  name: "change-password-view",
  components: {
    ChangePassword,
  },
};
</script>
